import * as angular from "angular";
import {IController, IQService, ITimeoutService, IWindowService} from "angular";
import * as _ from "lodash";
import {AgentModel} from "../../angular/models/agent.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {DataSet} from "vis-data";
import {TasksService} from "../../../tasks/services/tasks-service.service";
import {ResourcesAlertsService} from "../../../resources/services/resources-alerts.service";
import {BringozTimelineService} from "../../../commons/services/bringoz-timeline-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {LeanPlanningAlertsService} from "../../../lean-planning/services/lean-planning-alerts.factory";
import {LeanPlanningService} from "../../../lean-planning/services/lean-planning-service.service";
import {TaskDetailedServiceTimeModel} from "../../../tasks/models/task-detailed-service-time.model";
import {TasksDialogService} from "../../../tasks/services/tasks-dialog.service";
import {ScheduleType} from "../../../schedule/types/schedule.type";

export class AgentsScheduleTimelineBetaCtrl implements IController {
  agents: any;
  schedules: any;
  routes: any;
  tasks: TaskModel[];
  serviceAreas: any;
  totals: any;
  range: any;
  query: any;
  isLoading?: boolean;
  isSortMode?: boolean;
  isTooltipsEnabled?: boolean;
  isShowScheduleContentEnabled?: boolean;
  isShowTaskColorByAgent?: boolean;
  isShowUtilization?: boolean;
  agentsGroup: any;
  highlightedSchedules: any;
  highlightedTasks: any;
  isFavouriteAgentsMode?: boolean;
  favouriteAgentIds?: string[];
  settings?: any;
  onScheduleSelect: Function;
  onViewService: Function;
  onAxisClick: Function;
  onBreakRightClick: Function;
  onRightClickTask: Function;
  onRightClickSchedule: Function;
  onCreateSchedule: Function;
  onMoveGroup: Function;
  onMoveItem: Function;
  onTaskChange: Function;
  onDatesPageChange: Function;
  onAgentsGroupChange: Function;
  onToggleHighlightSchedule: Function;
  onHighlightedItemsChange: Function;
  onAgentColorClick: Function;
  onToggleIsFavouriteAgentsMode: Function;
  onToggleFavouriteAgent: Function;
  onResetFavouriteAgents: Function;
  onUpdateShift: Function;
  onSort: Function;
  onSettingsChange: Function;
  addServicesToRoute: Function;
  addServicesToNewRoute: Function;

  private container: any;
  private vis: any;
  private rrule: any;
  private options: any;
  private timeline: any;
  private tableHeaderDivRef: any;
  private groupsDataSet: any;
  private readonly timeFormat: any;
  private readonly shortDateFormat: any;
  private readonly longDateFormat: any;
  private timeZone: any;
  private purposeToSkillMap: any;
  private serviceFinishStatuses: string[];
  private itemsDataSet: any;
  private isExpandedRoutes: any;
  private colorPallet: any;


  ////////////////////////////// ICONS //////////////////////////////
  private iconsUrl: any;
  private $agentTypeIcon: any;
  private $emptyStarIcon: any;
  private $fullStarIcon: any;
  private readonly $branchIcon: any;
  private readonly $serviceAreaIcon: any;
  private readonly $employmentTypeIcon: any;
  private readonly $skillsIcon: any;
  private $recurringIcon: any;
  private $resourceIcon: any;
  private $routedRowIcon: any;
  private $routedWhiteIcon: any;

  public groupsViewSettings: any;
  public siteSkills: any;

  // Single delegated click handler for group-row actions, attached once on
  // `this.container` after the timeline is created. Replaces 3 per-cell
  // `addEventListener` calls inside `groupTemplate`.
  private readonly _onContainerClick = (event: Event) => {
    const target = event.target as Element | null;
    if (!target) return;
    const actionEl = target.closest('[data-bz-action]') as HTMLElement | null;
    if (!actionEl) return;
    const action = actionEl.dataset.bzAction;
    const id = actionEl.dataset.bzId;
    if (!action || !id) return;
    this._onClicked().then(() => {
      if (action === 'agent-color') {
        const group: any = this.groupsDataSet ? this.groupsDataSet.get(id) : null;
        if (group?.ref && group.agentId) {
          this.onAgentColorClick({agent: group.ref, color: this._getColorByAgentId(group.agentId)});
        }
      } else if (action === 'toggle-favourite-agent') {
        this.onToggleFavouriteAgent({agentId: id});
      } else if (action === 'view-agent-schedule') {
        const siteId = this.splitService.getSiteId();
        const url = this.$state.href('agent.agent-profile.schedule', {id: id, siteId: siteId});
        this.$window.open(url, '_blank');
      }
    });
  };

  constructor(private $q: IQService, private confirmDialogService: ConfirmDialogService, private $filter, private splitService: SplitService, private commonsService: CommonsService,
              private leanPlanningConstants, private resourcesAlertsService: ResourcesAlertsService, private leanPlanningAlertsService: LeanPlanningAlertsService,
              private commonsDialogService: CommonsDialogService, private moment, private $timeout: ITimeoutService, private bringozTimelineService: BringozTimelineService,
              private $log, private tasksService: TasksService, private commonsConstants, private deliveriesConstants, private $state, private $window: IWindowService,
              private leanPlanningService: LeanPlanningService, private tasksDialogService: TasksDialogService) {

    this.vis = require('vis-timeline');
    this.rrule = require('rrule');

    const dateAndTimeConfig = splitService.getDateAndTimeConfig();
    this.timeFormat = dateAndTimeConfig.time;
    this.shortDateFormat = dateAndTimeConfig.date;
    this.longDateFormat = dateAndTimeConfig.long;
    this.timeZone = splitService.getTimeZone();
    this.siteSkills = splitService.getSiteResourceSkills();

    this.purposeToSkillMap = {
      Pickup: ['Delivery'],
      Dropoff: ['Delivery'],
      Operation: ['Merchandise', 'Order']
    };
    this.serviceFinishStatuses = this.deliveriesConstants.serviceFinishStatuses;


    this.iconsUrl = {
      emptyStar: 'assets/images/icons/v2/skill-outline.svg',
      fullStar: 'assets/images/icons/v2/skill.svg',
      agentType: 'assets/images/icons/v2/agent.svg',
      branch: 'assets/images/icons/v2/branch.svg',
      serviceArea: 'assets/images/icons/v2/service-area.svg',
      employmentType: 'assets/images/icons/v2/dollar-circle.svg',
      skill: 'assets/images/icons/v2/skill.svg',
      recurring: 'assets/images/icons/v2/recurring.svg',
      resource: 'assets/images/icons/v2/tiles-outline.svg',
      routed: 'assets/images/icons/v2/route.svg',
      Bicycle: 'assets/images/icons/v2/bicycle.svg',
      Motorcycle: 'assets/images/icons/v2/motorcycle.svg',
      PrivateCar: 'assets/images/icons/v2/privatecar.svg',
      Van: 'assets/images/icons/v2/van.svg',
      Truck: 'assets/images/icons/v2/truck.svg',
      Forklift: 'assets/images/icons/v2/forklift.svg',
      Trailer: 'assets/images/icons/v2/trailer.svg',
      Tractor: 'assets/images/icons/v2/tractor.svg',
      ElectricCar: 'assets/images/icons/v2/electriccar.svg',
      ElectricTruck: 'assets/images/icons/v2/electrictruck.svg',
      ElectricVan: 'assets/images/icons/v2/electricvan.svg'
    }

    this.$emptyStarIcon = document.createElement('IMG');
    this.$emptyStarIcon.setAttribute("src", this.iconsUrl.emptyStar);
    this.$emptyStarIcon.classList.add('bringoz-icon-16', 'gray');

    this.$fullStarIcon = document.createElement('IMG');
    this.$fullStarIcon.setAttribute("src", this.iconsUrl.fullStar);
    this.$fullStarIcon.classList.add('bringoz-icon-16', 'gray');

    this.$agentTypeIcon = document.createElement('IMG');
    this.$agentTypeIcon.setAttribute("src", this.iconsUrl.agentType);
    this.$agentTypeIcon.classList.add('bringoz-icon-small', 'gray');

    this.$serviceAreaIcon = document.createElement('IMG');
    this.$serviceAreaIcon.setAttribute("src", this.iconsUrl.serviceArea);
    this.$serviceAreaIcon.classList.add('bringoz-icon-small', 'gray');

    this.$branchIcon = document.createElement('IMG');
    this.$branchIcon.setAttribute("src", this.iconsUrl.branch);
    this.$branchIcon.classList.add('bringoz-icon-small', 'gray');

    this.$employmentTypeIcon = document.createElement('IMG');
    this.$employmentTypeIcon.setAttribute("src", this.iconsUrl.employmentType);
    this.$employmentTypeIcon.classList.add('bringoz-icon-small', 'gray');


    this.$skillsIcon = document.createElement('IMG');
    this.$skillsIcon.setAttribute("src", this.iconsUrl.skill);
    this.$skillsIcon.classList.add('bringoz-icon-small', 'gray');


    this.$recurringIcon = document.createElement('IMG');
    this.$recurringIcon.setAttribute("src", this.iconsUrl.recurring);
    this.$recurringIcon.classList.add('bringoz-icon-small', 'white');


    this.$resourceIcon = document.createElement('IMG');
    this.$resourceIcon.setAttribute("src", this.iconsUrl.resource);
    this.$resourceIcon.classList.add('bringoz-icon-small');


    this.$routedRowIcon = document.createElement('IMG');
    this.$routedRowIcon.setAttribute("src", this.iconsUrl.routed);
    this.$routedRowIcon.classList.add('bringoz-icon-small', 'gray');


    this.$routedWhiteIcon = document.createElement('IMG');
    this.$routedWhiteIcon.setAttribute("src", this.iconsUrl.routed);
    this.$routedWhiteIcon.classList.add('bringoz-icon-small', 'white');
  }

  $onInit() {

    this.groupsViewSettings = this.settings ? angular.copy(this.settings) : {
      vehicleType: true,
      serviceAreas: true,
      skills: true,
      tags: true,
      branches: true
    }

    this.isExpandedRoutes = true;
    this.colorPallet = this.commonsConstants.colorPalletTwo;

    // create visualization
    this.container = document.getElementById('timeline');

    // Set Timeline
    this.groupsDataSet = new DataSet();
    this.itemsDataSet = new DataSet();

    const numberOfAgents = _.get(this.agents, 'length', 0);

    // Set Options
    this.options = {
      groupOrder: (a, b) => {
        return a.order - b.order;
      },
      groupOrderSwap: (groupDragged, groupToSwap) => {
        const value = groupDragged.order;
        groupDragged.order = groupToSwap.order;
        groupToSwap.order = value;
      },
      onMoveGroup: (groupMoved) => {
        this.onMoveGroup({agentId: groupMoved.agentId, index: groupMoved.order})
      },
      groupTemplate: (group) => {

        // const routesCount = _.filter(this.routes, (r) => {
        //   return _.get(r, 'agentId') === _.get(group, 'ref.id')
        // }).length;

        if (!group) {
          return null;
        }

        const mainContainer = document.createElement('div');
        mainContainer.classList.add("group-container");

        const groupColor = this._getColorByAgentId(group.agentId);
        const colorContainer = document.createElement('div');
        colorContainer.setAttribute('style', `background: ${groupColor}`);
        colorContainer.classList.add("group-color-container");
        if (group.id) {
          colorContainer.dataset.bzAction = 'agent-color';
          colorContainer.dataset.bzId = String(group.id);
        }

        const favouriteContainer = document.createElement('div');
        favouriteContainer.classList.add("group-favourite-container");
        const starIcon = _.includes(this.favouriteAgentIds || [], group.id) ?
          this.$fullStarIcon.cloneNode(true) :
          this.$emptyStarIcon.cloneNode(true);
        starIcon.classList.add("group-icon");
        favouriteContainer.insertAdjacentElement('beforeend', starIcon);
        if (group.id) {
          favouriteContainer.dataset.bzAction = 'toggle-favourite-agent';
          favouriteContainer.dataset.bzId = String(group.id);
        }

        const infoContainer = document.createElement('div');
        infoContainer.classList.add("group-info-container");


        // Agent Name / Skills Row

        // Agent Name
        const nameRow = document.createElement('div');
        nameRow.classList.add("group-info-row");

        const groupNameSpan = document.createElement('a');
        groupNameSpan.classList.add("agent-name", "text-ellipsis", "br-body-2", "font-weight-600");
        groupNameSpan.innerText = group.name;
        if (group.agentId) {
          groupNameSpan.dataset.bzAction = 'view-agent-schedule';
          groupNameSpan.dataset.bzId = String(group.agentId);
        }

        nameRow.insertAdjacentElement('beforeend', groupNameSpan);

        const agentStatusDiv = document.createElement('div');
        agentStatusDiv.classList.add("agent-status", group.status);

        nameRow.insertAdjacentElement('beforeend', agentStatusDiv);

        // Vehicle Type Row
        let vehicleTypeRow;
        if (this.groupsViewSettings.vehicleType) {

          vehicleTypeRow = document.createElement('div');
          const icon = document.createElement('IMG');
          icon.setAttribute("src", this.iconsUrl[group.vehicleType]);
          icon.classList.add("bringoz-icon-small", "gray", "group-icon");
          this.$branchIcon.classList.add('bringoz-icon-small', 'gray')
          vehicleTypeRow.insertAdjacentElement('beforeend', icon);

          vehicleTypeRow.classList.add("group-info-row");
          const vehicleTypeSpan = document.createElement('span');
          vehicleTypeSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
          vehicleTypeSpan.textContent = this.$filter('translate')(group.vehicleType);
          vehicleTypeRow.insertAdjacentElement('beforeend', vehicleTypeSpan);
        }

        // Tags
        if (this.groupsViewSettings.tags && group.tags?.length) {
          group.tags.forEach((t) => {
            const tag = document.createElement('div');
            tag.classList.add('skill-tag');

            const skillText = document.createElement('span')
            skillText.textContent = t;
            tag.appendChild(skillText);
            nameRow.insertAdjacentElement('beforeend', tag);
          })
        }

        // Skills
        if (this.groupsViewSettings.skills && group.skills?.length) {
          group.skills.forEach((s) => {
            const skill = document.createElement('div');
            skill.classList.add('skill-tag');

            const skillText = document.createElement('span')
            skillText.textContent = s;
            skill.appendChild(skillText);
            vehicleTypeRow.insertAdjacentElement('beforeend', skill);
          })
        }

        // Service Areas Row
        let serviceAreasRow;
        if (this.groupsViewSettings.serviceAreas) {

          serviceAreasRow = document.createElement('div');

          const icon = this.$serviceAreaIcon.cloneNode(true);
          icon.classList.add("group-icon");
          serviceAreasRow.insertAdjacentElement('beforeend', icon);

          if (group.priorityServiceAreas?.length) {
            serviceAreasRow.classList.add("group-info-row");
            const serviceAreasSpan = document.createElement('span');
            serviceAreasSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
            serviceAreasSpan.innerText = group.priorityServiceAreas[0].areaName;

            serviceAreasRow.insertAdjacentElement('beforeend', serviceAreasSpan);

            if (group.priorityServiceAreas.length > 1) {
              const extraServiceAreasSpan = document.createElement('span');
              extraServiceAreasSpan.classList.add("extra-count", "text-ellipsis", "br-caption-2", "font-weight-500", "color-primary-100");
              extraServiceAreasSpan.textContent = `+${group.priorityServiceAreas.length - 1}`
              serviceAreasRow.insertAdjacentElement('beforeend', extraServiceAreasSpan);
            }
          } else {
            const allSpan = document.createElement('span');
            allSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
            allSpan.textContent = this.$filter('translate')('All');
            serviceAreasRow.insertAdjacentElement('beforeend', allSpan);
          }
        }


        // Branches Row
        let branchesRow;
        if (this.groupsViewSettings.branches) {

          branchesRow = document.createElement('div');

          const icon = this.$branchIcon.cloneNode(true);
          icon.classList.add("group-icon");
          branchesRow.insertAdjacentElement('beforeend', icon);

          if (group.branchReferences?.length) {
            branchesRow.classList.add("group-info-row");
            const branchesSpan = document.createElement('span');
            branchesSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
            branchesSpan.innerText = group.branchReferences[0].name;

            branchesRow.insertAdjacentElement('beforeend', branchesSpan);

            if (group.branchReferences.length > 1) {
              const extraBranchesSpan = document.createElement('span');
              extraBranchesSpan.classList.add("extra-count", "text-ellipsis", "br-caption-2", "font-weight-500", "color-primary-100");
              extraBranchesSpan.textContent = `+${group.branchReferences.length - 1}`
              branchesRow.insertAdjacentElement('beforeend', extraBranchesSpan);
            }
          } else {
            const allSpan = document.createElement('span');
            allSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
            allSpan.textContent = this.$filter('translate')('All');
            branchesRow.insertAdjacentElement('beforeend', allSpan);
          }
        }

        infoContainer.insertAdjacentElement('beforeend', nameRow);

        if (vehicleTypeRow) {
          infoContainer.insertAdjacentElement('beforeend', vehicleTypeRow.cloneNode(true));
        }

        if (serviceAreasRow) {
          infoContainer.insertAdjacentElement('beforeend', serviceAreasRow.cloneNode(true));
        }
        if (branchesRow) {
          infoContainer.insertAdjacentElement('beforeend', branchesRow.cloneNode(true));
        }

        mainContainer.insertAdjacentElement('beforeend', colorContainer);
        mainContainer.insertAdjacentElement('beforeend', favouriteContainer);
        mainContainer.insertAdjacentElement('beforeend', infoContainer);

        return mainContainer;
      },
      onMoving: (item, callback) => {
        if (item.purpose === 'Break') {
          callback(null);
          return;
        }

        if (item.itemType === 'SCHEDULE') {
          callback(item);
          return;
        }

        const routeRef = this.routes.find(r => r.id === item.routeId);

        const actions = this.leanPlanningService.getRoutesActionsMap([routeRef]);
        if (!actions.editRoute) {
          callback(null);
          return;
        }

        callback(item); // updating the item
      },
      onMove: (item, callback) => {

        if (item.purpose === 'Break') {
          callback(null);
          return;
        }

        if (item.itemType === 'SCHEDULE') {
          const shift = angular.copy(item.ref);
          shift.agentSchedule.schedule.startTime = item.start.valueOf();
          shift.agentSchedule.schedule.endTime = item.end.valueOf();
          this.onUpdateShift({shift: shift, updateSpecificDay: true, callback: callback})
          return;
        }

        const serviceIds = item.serviceIds || [item.serviceId];
        const groupToRef = this.groupsDataSet.get([item.group])[0];
        const routeFromRef = _.find(this.routes, ['id', item.ref.routeId]);

        const routeToRef = _.find(this.routes, (route) => {
          return route.planningResource.allocationId === _.get(groupToRef, 'ref.id') &&
            (
              _.isEqual(this.moment(item.start).valueOf(), this.moment(route.notBefore).valueOf()) ||
              _.isEqual(this.moment(item.end).valueOf(), this.moment(route.notAfter).valueOf()) ||
              this.moment(item.start).isBetween(this.moment(route.notBefore), this.moment(route.notAfter))
            );
        });

        let schedulesItems;
        let schedulesIds;
        let fromRouteId = item.routeId;
        let toRouteId;
        let isBetweenRoutes = false;
        let isBetweenDays = !this.moment(this.moment(item.start).format("MM/DD/YYYY")).isSame(this.moment(item.startTime).format("MM/DD/YYYY")) &&
          !this.moment(this.moment(item.end).format("MM/DD/YYYY")).isSame(this.moment(item.endTime).format("MM/DD/YYYY"));

        callback(item);

        if (!_.intersectionWith(groupToRef.requiredSkills, this.purposeToSkillMap[item.purpose], _.isEqual).length) {
          this.resourcesAlertsService.timelineNoMatchingSkillsInfo();
          callback(null);
          return;
        }

        const canMoveFromRoute = this.leanPlanningService.getRoutesActionsMap([routeFromRef]).editRoute;
        const canMoveToRoute = isBetweenRoutes ? this.leanPlanningService.getRoutesActionsMap([routeToRef]).editRoute : true;

        if (!canMoveFromRoute || !canMoveToRoute) {
          this.resourcesAlertsService.timelineNoMatchingCompletedOrCanceledInfo();
          callback(null);
          return;
        }


        if (!!routeToRef) {
          toRouteId = _.get(routeToRef, 'id');
          isBetweenRoutes = !_.isEqual(fromRouteId, toRouteId);
        } else {
          schedulesItems = this._schedulesToMoveTo(item);
          schedulesIds = _.map(schedulesItems, 'id');

          if (!schedulesIds.length) {
            this.resourcesAlertsService.timelineNoScheduleInfo();
            callback(null);
            return;
          } else {
            const selectedSchedule = schedulesItems[0];
            const selectedScheduleConnectedRoute = _.find(_.get(selectedSchedule, 'ref.scheduleExtraData', []), (extraDataItem) => {
              return !!extraDataItem.routeId && this.moment(this.moment(extraDataItem.eventDate).format("MM/DD/YYYY")).isSame(this.moment(selectedSchedule.start).format("MM/DD/YYYY"));
            });
            if (!!selectedScheduleConnectedRoute) {
              this.resourcesAlertsService.timelineMultipleRoutesOnShiftInfo();
              callback(null);
              return;
            }
          }
        }

        if (((!_.isEqual(item.startTime.valueOf(), item.start.valueOf()) && _.isEqual(item.endTime.valueOf(), item.end.valueOf()))
            || _.isEqual(item.startTime.valueOf(), item.start.valueOf()) && !_.isEqual(item.endTime.valueOf(), item.end.valueOf())) &&
          (fromRouteId === toRouteId)) {

          if (!item.ref.taskSpec.detailedServiceTime) {
            this.confirmDialogService.confirm('Update Task', 'Are you sure you want to update task?')
              .then(() => {
                const serviceTime = this.moment(item.end.valueOf()).diff(this.moment(item.start.valueOf()));
                this.onTaskChange({
                  id: item.id,
                  routeId: fromRouteId,
                  serviceTime: serviceTime
                });
              })
              .catch((error) => {
                callback(null);
              })
          } else {
            const route = this.routes.find(r => r.id === fromRouteId);
            const taskServiceTime = _.get(route.analysis[item.id], 'serviceTime');
            let originTaskEta = _.get(route.analysis[item.id], 'eta');
            const originTaskEtd = _.get(route.analysis[item.id], 'etd') || (originTaskEta + taskServiceTime);

            const taskNotBefore = _.get(item.ref, 'taskSpec.notBefore');

            if (originTaskEta < taskNotBefore) {
              originTaskEta = taskNotBefore
            }

            const originDiff = originTaskEtd - originTaskEta;
            const updatedDiff = this.moment(item.end.valueOf()).diff(this.moment(item.start.valueOf()));

            const percentageChange = updatedDiff / originDiff;

            const originalDetailedServiceTime = item.ref.taskSpec.detailedServiceTime;

            const updatedDetailedServiceTime: TaskDetailedServiceTimeModel = {
              entryTime: Math.round((originalDetailedServiceTime.entryTime || 0) * percentageChange),
              exitTime: Math.round((originalDetailedServiceTime.exitTime || 0) * percentageChange),
              workTime: Math.round((originalDetailedServiceTime.workTime || 0) * percentageChange),
              packagesTime: Math.round((originalDetailedServiceTime.packagesTime || 0) * percentageChange)
            }

            this.tasksDialogService.confirmDetailedServiceTimeChange(originalDetailedServiceTime, updatedDetailedServiceTime)
              .then((updatedDetailedServiceTime) => {
                this.onTaskChange({
                  id: item.id,
                  routeId: fromRouteId,
                  detailedServiceTime: updatedDetailedServiceTime
                });
              })
              .catch((error) => {
                callback(null);
              })
          }

        } else {
          let isUnassigned = _.isEqual(_.get(routeToRef, 'status'), 'Unassigned');
          const header = !!routeToRef ? (isBetweenRoutes ? 'Move service between routes' : 'Move service in route') : 'Create new route';
          const text = !!routeToRef ?
            (isBetweenRoutes ? 'Would you like to move this service to a another route?' : 'would you like to move this service in the route?') :
            'You are about to create a new route';

          const actions = !!routeToRef ? (_.isEqual(_.get(routeToRef, 'status'), 'Unassigned') ?
            this.commonsService.getConfirmActions(['Reset Services']) :
            this.commonsService.getConfirmActions(['Assign service to the route associated agent'])) : undefined;
          this.confirmDialogService.confirmWithActions(header, text, actions)
            .then((payload) => {

              const fromResourceId = item.resourceId;
              const groupsMap = this.timeline.components[3].groups;
              const isBetweenRoutes = !_.isUndefined(toRouteId) && (fromRouteId !== toRouteId);

              const fromOrderedIds = _.chain(groupsMap[fromResourceId].orderedItems.byStart)
                .filter((orderedItem) => {
                  return !_.isEqual(orderedItem.data.type, 'background') &&
                    (_.isEqual(orderedItem.data.id, item.id) || _.isEqual(orderedItem.data.routeId, fromRouteId));
                })
                .map((filteredItem) => {
                  return filteredItem.data.taskIdList || filteredItem.data.taskId;
                })
                .flatten()
                .value();

              const toOrderedIds = isBetweenRoutes ?
                _.chain(groupsMap[item.group].orderedItems.byStart)
                  .filter((orderedItem) => {
                    return !_.isEqual(orderedItem.data.type, 'background') &&
                      (_.isEqual(orderedItem.data.id, item.id) || _.isEqual(orderedItem.data.routeId, toRouteId));
                  })
                  .map((filteredItem) => {
                    return filteredItem.data.taskIdList || filteredItem.data.taskId;
                  })
                  .flatten()
                  .value() : undefined;


              if (isBetweenRoutes) {
                const tasks = this.tasks;
                const complementaryTaskIndex = this.tasksService.getComplementaryTaskIndex(item.ref, tasks);

                if (complementaryTaskIndex > -1) {
                  const currentItemIndex = _.findIndex(toOrderedIds, (id) => {
                    return id === item.id;
                  })
                  const complementaryTaskRef = tasks[complementaryTaskIndex];
                  const complementaryTaskId = tasks[complementaryTaskIndex].bundledTaskList ?
                    _.find(tasks[complementaryTaskIndex].bundledTaskList, (task: TaskModel) => {
                      return _.includes(serviceIds, task.serviceId);
                    }).id : complementaryTaskRef.id;
                  const isPickup = item.purpose === 'Pickup';
                  toOrderedIds.splice((isPickup ? (currentItemIndex + 1) : currentItemIndex), 0, complementaryTaskId);
                }
              }
              // const isRecurring = !!schedulesItems[0] && !!schedulesItems[0]?.ref?.agentSchedule.templateId && !schedulesItems[0]?.ref?.agentSchedule.overridden;
              this.onMoveItem(
                {
                  serviceIds: serviceIds,
                  fromRouteId: fromRouteId,
                  toRouteId: toRouteId,
                  fromOrderedIds: fromOrderedIds,
                  toOrderedIds: toOrderedIds,
                  scheduleInstanceId: _.get(schedulesIds, 'length') ? schedulesIds[0] : undefined,
                  originalId: _.get(schedulesItems, '[0].ref.agentSchedule.id'),
                  // originalId: isRecurring ? _.get(schedulesItems, '[0].ref.agentSchedule.id') : undefined,
                  agentId: _.get(schedulesItems, 'length') ? schedulesItems[0].group : undefined,
                  isBetweenDays: isBetweenDays,
                  toDate: item.start,
                  item: item,
                  assignServices: !isBetweenRoutes ? undefined : (isUnassigned ? undefined : payload[0].enabled),
                  resetServices: !isBetweenRoutes ? undefined : (isUnassigned ? payload[0].enabled : undefined),
                  callback: callback
                }
              );
            })
            .catch((error) => {
              callback(null);
              this.$log.info('onMoveTask Error', error);
            })
        }


      },
      onAdd: (data, callback) => {

        if (!data.items?.length) {
          callback(null);
          return;
        }

        const groupToRef = this.groupsDataSet.get([data.group])[0];
        const routeToRef = _.find(this.routes, (route) => {
          return route.planningResource.allocationId === _.get(groupToRef, 'ref.id') &&
            (
              _.isEqual(this.moment(data.start).valueOf(), this.moment(route.notBefore).valueOf()) ||
              _.isEqual(this.moment(data.start).valueOf(), this.moment(route.notAfter).valueOf()) ||
              this.moment(data.start).isBetween(this.moment(route.notBefore), this.moment(route.notAfter))
            );
        });

        const routeId = _.get(routeToRef, 'id');
        const serviceIds = _.map(data.items, 'id');

        let status;
        const finishedService = data.items.find((i) => {
          const isFinished = this.serviceFinishStatuses.includes(i.data.status);
          if (isFinished) {
            status = i.data.status;
          }
          return isFinished;
        })
        if (!!finishedService) {
          this.leanPlanningAlertsService.serviceFinishedInfo(status);
          callback(null);
          return;
        }

        const missingSkillsService = data.items.find((i) => {
          return !_.intersectionWith(groupToRef.requiredSkills, i.data.requiredSkills, _.isEqual).length;
        })
        if (!!missingSkillsService) {
          this.resourcesAlertsService.timelineNoMatchingSkillsInfo();
          callback(null);
          return;
        }

        if (routeToRef) {
          // Add Services To Route
          this.addServicesToRoute({
            routeId: routeId,
            serviceIds: serviceIds
          });

        } else {
          // Create Route From Services
          const schedulesItems = this._schedulesToMoveTo(data);
          const schedulesIds = _.map(schedulesItems, 'id');


          if (!schedulesIds.length) {
            this.resourcesAlertsService.timelineNoScheduleInfo();
            callback(null);
            return;
          } else {
            const selectedSchedule = schedulesItems[0];
            const selectedScheduleConnectedRoute = _.find(_.get(selectedSchedule, 'ref.scheduleExtraData', []), (extraDataItem) => {
              return !!extraDataItem.routeId && this.moment(this.moment(extraDataItem.eventDate).format("MM/DD/YYYY")).isSame(this.moment(selectedSchedule.start).format("MM/DD/YYYY"));
            });
            if (!!selectedScheduleConnectedRoute) {
              this.resourcesAlertsService.timelineMultipleRoutesOnShiftInfo();
              callback(null);
              return;
            }

            this.addServicesToNewRoute({
              allocationInstanceId: _.get(schedulesIds, 'length') ? schedulesIds[0] : undefined,
              allocationTimeWindowId: _.get(schedulesItems, '[0].ref.agentSchedule.id'),
              serviceIdList: serviceIds,
              notBefore: this.moment(data.start).startOf('day').valueOf(),
              notAfter: this.moment(data.start).endOf('day').valueOf()
            })
          }
        }


        // const groupsMap = this.timeline.components[3].groups;
        // const serviceIds = _.flatMap(data.items, 'id');
        // const groupToRef = this.groupsDataSet.get([data.group])[0];
        // const routeFromRef = _.find(this.routes, ['id', serviceRef.routeId]);
        // const routeToRef = _.find(this.routes, (route) => {
        //   return route.planningResource.allocationId === _.get(groupToRef, 'ref.id') &&
        //     (
        //       _.isEqual(this.moment(data.start).valueOf(), this.moment(route.notBefore).valueOf()) ||
        //       _.isEqual(this.moment(data.start).valueOf(), this.moment(route.notAfter).valueOf()) ||
        //       this.moment(data.start).isBetween(this.moment(route.notBefore), this.moment(route.notAfter))
        //     );
        // });
        // const fromRouteId = _.get(serviceRef, 'routeId');
        // const toRouteId = _.get(routeToRef, 'id');
        // const isBetweenRoutes = (!!fromRouteId && !!toRouteId) && !_.isEqual(fromRouteId, toRouteId);
        //
        // if (!_.intersectionWith(groupToRef.requiredSkills, serviceRef.requiredSkills, _.isEqual).length) {
        //   this.resourcesAlertsService.timelineNoMatchingSkillsInfo();
        //   callback(null);
        //   return;
        // }
        //
        // if (!!fromRouteId && !!toRouteId && (fromRouteId === toRouteId)) {
        //   this.leanPlanningAlertsService.alreadyInRouteInfo();
        //   callback(null);
        //   return;
        // }
        //
        // const canMoveFromRoute = !!routeFromRef ? this.leanPlanningService.getRoutesActionsMap([routeFromRef]).editRoute : true;
        // const canMoveToRoute = isBetweenRoutes ? this.leanPlanningService.getRoutesActionsMap([routeToRef]).editRoute : true;
        //
        // if (!canMoveFromRoute || !canMoveToRoute) {
        //   this.resourcesAlertsService.timelineNoMatchingCompletedOrCanceledInfo();
        //   callback(null);
        //   return;
        // }
        //
        //
        // let toOrderedIds;
        // let schedulesItems;
        // let schedulesIds;
        // // let isBetweenDays;
        //
        // // if (!!fromRouteId) {
        // //   isBetweenDays = true;
        // // }
        //
        // let isBetweenDays = !this.moment(this.moment(data.start).format("MM/DD/YYYY")).isSame(this.moment(serviceRef.notBefore).format("MM/DD/YYYY")) &&
        //   !this.moment(this.moment(data.start).format("MM/DD/YYYY")).isSame(this.moment(serviceRef.notAfter).format("MM/DD/YYYY"));
        //
        //
        // if (!!routeToRef) {
        //   toOrderedIds = _.chain(groupsMap[data.group].orderedItems.byStart)
        //     .filter((orderedItem) => {
        //       return _.isEqual(orderedItem.data.itemType, 'TASK');
        //     })
        //     .map((filteredItem) => {
        //       return filteredItem.data.taskIdList || filteredItem.data.taskId;
        //     })
        //     .flatten()
        //     .value()
        // } else {
        //   schedulesItems = this._schedulesToMoveTo(data);
        //   schedulesIds = _.map(schedulesItems, 'id');
        //
        //   if (!schedulesIds.length) {
        //     this.resourcesAlertsService.timelineNoScheduleInfo();
        //     callback(null);
        //     return;
        //   } else {
        //     const selectedSchedule = schedulesItems[0];
        //     const selectedScheduleConnectedRoute = _.find(_.get(selectedSchedule, 'ref.scheduleExtraData', []), (extraDataItem) => {
        //       return !!extraDataItem.routeId && this.moment(this.moment(extraDataItem.eventDate).format("MM/DD/YYYY")).isSame(this.moment(selectedSchedule.start).format("MM/DD/YYYY"));
        //     });
        //     if (!!selectedScheduleConnectedRoute) {
        //       this.resourcesAlertsService.timelineMultipleRoutesOnShiftInfo();
        //       callback(null);
        //       return;
        //     }
        //   }
        // }
        //
        // this.onMoveItem(
        //   {
        //     serviceIds: serviceIds,
        //     fromRouteId: fromRouteId,
        //     toRouteId: toRouteId,
        //     toOrderedIds: toOrderedIds,
        //     scheduleInstanceId: _.get(schedulesIds, 'length') ? schedulesIds[0] : undefined,
        //     originalId: _.get(schedulesItems, '[0].ref.agentSchedule.id'),
        //     agentId: _.get(schedulesItems, 'length') ? schedulesItems[0].group : undefined,
        //     isBetweenDays: isBetweenDays,
        //     toDate: data.start,
        //     item: data.items[0],
        //     assignServices: undefined,
        //     resetServices: undefined,
        //     callback: callback
        //   }
        // );

      },
      snap: function (date, scale, step) {
        var time = 900000; // 15 mins
        return Math.round(date / time) * time;
      },
      // editable: true,
      selectable: true,
      multiselect: true,
      multiselectPerGroup: true,
      xss: {
        disabled: true,
        // filterOptions: {
        //   whiteList: { p: ['class', 'data-from-template'], div: 'class' },
        // },
      },
      editable: {
        add: true,                          // add new items by double tapping
        updateTime: !this.isLoading,                   // drag items horizontally
        updateGroup: false,              // drag items from one group to another
        remove: false,                 // delete an item by tapping the delete button top right
        overrideItems: this.isLoading          // allow these options to override item.editable
      },
      showTooltips: !!this.isTooltipsEnabled,
      tooltip: {
        followMouse: true
      },
      verticalScroll: true,
      zoomKey: "ctrlKey",
      // tooltipOnItemUpdateTime: {
      //   template: function(item) {
      //     // Option to add tooltip when dragging item (useful)
      //     return 'html template for tooltip with <b>item.start</b>: ' + item.start;
      //   }
      // },
      orientation: numberOfAgents < 3 ? "top" : "both",
      groupEditable: true,
      width: '100%',
      // height: '100%',
      margin: {
        item: {horizontal: 10, vertical: 0},
        axis: 5
      },
      minHeight: '360px',
      stack: false,
      format: {
        minorLabels: {
          minute: this.timeFormat,
          hour: this.timeFormat,
          millisecond: this.timeFormat,
          second: this.timeFormat,
          weekday: 'ddd ' + this.shortDateFormat,
          day: 'ddd ' + this.shortDateFormat,
          week: 'ddd ' + this.shortDateFormat,
          month: this.shortDateFormat,
          year: this.longDateFormat
        },
        majorLabels: {
          millisecond: 'ddd ' + this.shortDateFormat,
          second: 'ddd ' + this.shortDateFormat,
          minute: 'ddd ' + this.shortDateFormat,
          hour: 'ddd ' + this.shortDateFormat,
          weekday: '',
          day: 'ddd ' + this.shortDateFormat,
          week: '',
          month: '',
          year: ''
        }
      },
      start: this.range.dateStart ? this.moment(this.range.dateStart).subtract(1, 'hour') : this.moment().startOf('day'),
      end: this.range.dateEnd ? this.moment(this.range.dateEnd).add(1, 'hour') : this.moment().endOf('day'),
      min: this.range.dateStart ? this.moment(this.range.dateStart) : this.moment().startOf('day'),
      max: this.range.dateEnd ? this.moment(this.range.dateEnd) : this.moment().endOf('day'),
      zoomable: false,
      moveable: false
    };

    this.timeline = new this.vis.Timeline(this.container, [], this.options);

    // Single delegated click handler — replaces per-cell addEventListener calls
    // inside groupTemplate so listener count stays O(1) regardless of vis redraws.
    this.container.addEventListener('click', this._onContainerClick);

    // Set Timeline
    this.timeline.setGroups(this.groupsDataSet);
    this.timeline.setItems(this.itemsDataSet);

    // Set Table Actions
    const topElementRef = this.timeline.body.dom.top;
    topElementRef.style = 'left: 0px';
    this.tableHeaderDivRef = document.createElement("div");
    this.tableHeaderDivRef.classList.add("resources-list-header-container");

    topElementRef.before(this.tableHeaderDivRef);

    // Init Timeline
    if (this.agents?.length) {

      // Init Agents Groups
      this.groupsDataSet.add(this._getGroupsData(this.agents));

      // Init Routes Utilization/Task Items
      if (this.isShowUtilization) {

        // Add Routes Tasks Items
        if (this.routes?.length) {
          this.itemsDataSet.add(this._getRoutesUtilizationItemsData(this.routes));
        }
      } else {

        // Add Schedule Items
        if (this.schedules?.length) {
          this.itemsDataSet.add(this._getScheduleItemsData(this.schedules));
          this.itemsDataSet.add(this._getScheduleBreaksItemsData(this.schedules));
        }

        // Init Routes Items
        if (this.routes?.length) {

          // Add Routes Background Items
          this._addRoutesBackgroundToTimeline(this.routes);

          // Add Routes Tasks Items
          this.initRoutesTasks(this.tasks);
        }
      }
    }

    // DoubleClick Event
    this.timeline.on('doubleClick', (properties) => {
      this._onClicked().then(() => {

        if (properties.what === 'axis') {
          this.onAxisClick({date: this.moment(properties.time).valueOf()})
          return;
        }

        // Item Click
        if (properties.what === 'item') {
          const item = this.itemsDataSet.get(properties.item);

          // Schedule Click
          if (item.itemType === 'SCHEDULE') {
            const agentRef = _.find(this.agents, (a) => {
              return a.id === item.agentId
            });
            this.onScheduleSelect({
              schedule: item.ref,
              date: item.start.valueOf(),
              agent: agentRef
            });
          }

          // Breaks Click
          if (item.itemType === 'BREAK') {
            const scheduleRef = this.schedules.find((s) => {
              return s.id === item.scheduleId;
            })
            const agentRef = _.find(this.agents, (a) => {
              return a.id === item.agentId
            });
            this.onScheduleSelect({
              schedule: scheduleRef,
              date: item.start.valueOf(),
              agent: agentRef
            });
          }

          // Task Click
          if (item.itemType === 'TASK' && properties.what === 'item') {
            this.onViewService({ids: item.serviceIds || [item.serviceId]});
          }

        }

        let startDate;
        let endDate;
        if (properties.group && !_.get(properties, 'item')) {
          const agent = _.find(this.agents, (a) => {
            return a.id === properties.group
          });
          if (agent) {
            let selectedDate = undefined;
            if (_.isEqual(_.get(properties, 'what'), 'background') && _.get(properties, 'time')) {
              selectedDate = (properties.time).getTime();
              startDate = this.moment(selectedDate).startOf('day').valueOf()
              endDate = this.moment(selectedDate).endOf('day').minute(45).seconds(0).millisecond(0).valueOf();
            }
            this.onCreateSchedule({agent: agent, startDate: startDate, endDate: endDate});
          }
        }
      })
      properties.event.preventDefault();
    });

    this.timeline.itemSet.groupHammer.off('tap');

    // Select Event
    this.timeline.on('select', (properties) => {
      properties.event.preventDefault();
      this._onClicked().then(() => {
        const selectedItemIds = this.timeline.getSelection();

        const highlightedSchedules = [];
        let highlightedTasks = [];
        const highlightedRoutes = [];

        _.forEach(selectedItemIds, (itemId) => {
          const selectedItem = this.itemsDataSet.get(itemId);

          // const agent = _.find(this.agents, (a) => {
          //   return a.id === selectedItem.ref.agentId;
          // })

          if (selectedItem.itemType === 'SCHEDULE') {
            highlightedSchedules.push(selectedItem.ref)
            const scheduleRoute = this._getRouteByScheduleId(selectedItem.id);

            if (!!scheduleRoute) {
              scheduleRoute.color = this._getColorByAgentId(selectedItem.agentId);
              highlightedRoutes.push(scheduleRoute)
            }
          }

          if (selectedItem.itemType === 'BREAK') {
            const scheduleRef = _.find(this.schedules, (s) => {
              return selectedItem.scheduleId === s.id;
            })
            const scheduleRoute = this._getRouteByScheduleId(selectedItem.scheduleId);

            if (!!scheduleRef) {
              highlightedSchedules.push(scheduleRef)
            }

            if (!!scheduleRoute) {
              scheduleRoute.color = this._getColorByAgentId(selectedItem.agentId);
              highlightedRoutes.push(scheduleRoute)
            }
          }

          if (selectedItem.itemType === 'TASK') {
            highlightedTasks.push(selectedItem.ref)

            const route = _.find(this.routes, (r) => {
              return r.id === selectedItem.ref.routeId;
            })
            if (!!route &&
              !_.includes(selectedItemIds, selectedItem.ref.routeId) && !_.includes(_.map(highlightedRoutes, 'id'), selectedItem.ref.routeId)) {
              highlightedRoutes.push(route)
            }
          }

        })

        // Supporting only one task selected.
        if (highlightedTasks.length > 1) {
          highlightedTasks = [_.last(highlightedTasks)];
        }

        this.onHighlightedItemsChange({
          highlightedSchedules: _.uniq(highlightedSchedules),
          highlightedTasks: highlightedTasks,
          highlightedRoutes: highlightedRoutes
        });
        properties.event.preventDefault();
      });
    });

    // Right Click Event
    this.timeline.on('contextmenu', (properties) => {
      if (_.get(properties, 'item')) {
        const item = this.itemsDataSet.get(properties.item);
        const event = properties.event;

        if (item.itemType === 'TASK') {
          this._onClicked().then(() => {
            this.onRightClickTask({task: item.ref, agentId: item.agentId, event: event});
          })
        }

        if (item.itemType === 'BREAK') {
          this._onClicked().then(() => {
            const scheduleRef = this.schedules.find((s) => {
              return s.id === item.scheduleId;
            })
            this.onBreakRightClick({schedule: scheduleRef, breakId: _.get(item, 'ref.id'), event: event})
          })
        }

        if (item.itemType === 'SCHEDULE') {
          this._onClicked().then(() => {
            this.onRightClickSchedule({schedule: item.ref, event: event});
          })
        }

      }
      properties.event.preventDefault();
    });

    // Hover
    this.timeline.on('mouseOver', (props) => {
      if (props.item) {
        this._onClicked().then(() => {

        });
      }
    });

  };

  $onChanges(changes: angular.IOnChangesObject) {

    if (changes.settings && !changes.settings.isFirstChange()) {
      this.groupsViewSettings = this.settings ? angular.copy(this.settings) : {
        vehicleType: true,
        serviceAreas: true,
        skills: true,
        tags: true,
        branches: true
      };

      this.redrawGroupTemplate();
    }

    if ((changes.highlightedSchedules && !changes.highlightedSchedules.isFirstChange()) ||
      (changes.highlightedTasks && !changes.highlightedTasks.isFirstChange())) {
      this.$timeout().then(() => {
        const highlightedScheduleIds = _.map(this.highlightedSchedules, 'agentSchedule.id');
        const highlightedTaskIds = _.map(this.highlightedTasks, 'id');

        this.timeline.setSelection(_.concat(highlightedScheduleIds, highlightedTaskIds));
      })
    }

    if (changes.favouriteAgentIds && !changes.favouriteAgentIds.isFirstChange()) {
      this.$timeout(0).then(() => {
        this._setExpandedGroupsRoutes(this.isExpandedRoutes);
      })
    }

    if (changes.agents && !changes.agents.isFirstChange()) {
      const currentAgents = changes.agents.currentValue || [];
      const previousAgents = changes.agents.previousValue || [];

      const agentsToAdd = _.differenceBy(currentAgents, previousAgents, 'id');
      const agentsToRemove = _.differenceBy(previousAgents, currentAgents, 'id');


      const currentUpdatedAgents = _.differenceBy(currentAgents, agentsToAdd, 'id');
      const previousUpdatedAgents: any = _.differenceBy(previousAgents, agentsToRemove, 'id');

      const currentAgentsToUpdate = _.filter(currentUpdatedAgents, (currentUpdatedAgent: any) => {
        const previousUpdatedAgent = _.find(previousUpdatedAgents, ['id', currentUpdatedAgent.id]);
        // Check if route was changed
        return previousUpdatedAgent.updatedAt < currentUpdatedAgent.updatedAt;
      });

      // Remove
      if (agentsToRemove.length) {
        this.groupsDataSet.remove(_.map(agentsToRemove, 'id'));
      }


      // Update
      if (!!currentAgentsToUpdate.length) {
        const currentAgentsIdsToUpdate = _.map(currentAgentsToUpdate, 'id');
        const updatedGroups = this._getGroupsData(currentAgentsToUpdate);
        this.groupsDataSet.update(updatedGroups);

        // Redraw Items (If color changed)
        if (!this.isShowUtilization) {
          const tasksToUpdate = this.tasks.filter((t) => {
            return currentAgentsIdsToUpdate.includes(t.agentId);
          })
          this._redrawTasks(tasksToUpdate);
        }
      }

      // Add
      if (agentsToAdd.length) {
        this.groupsDataSet.add(this._getGroupsData(agentsToAdd));
      }

      // OLD
      // this.groupsDataSet.clear();
      // this.groupsDataSet.add(this._getGroupsData(this.agents));

      const numberOfAgents = _.get(this.agents, 'length', 0);
      this.options.height = numberOfAgents === 0 ? '100%' : null;
      this.options.orientation = numberOfAgents < 3 ? 'top' : 'both';
      this.timeline.setOptions(this.options);

      this.$timeout(0).then(() => {
        this._setExpandedGroupsRoutes(this.isExpandedRoutes, true);
      })
    }

    if (
      (changes.schedules && !changes.schedules.isFirstChange()) ||
      (changes.isShowScheduleContentEnabled && !changes.isShowScheduleContentEnabled.isFirstChange())
    ) {
      this._clearScheduleItems();
      this.itemsDataSet.add(this._getScheduleItemsData(this.schedules));
      this.itemsDataSet.add(this._getScheduleBreaksItemsData(this.schedules));
      // timeline.fit();
    }

    if (changes.routes && !changes.routes.isFirstChange()) {
      if (this.isShowUtilization) {
        this.itemsDataSet.clear();
        this.itemsDataSet.add(this._getRoutesUtilizationItemsData(this.routes));
      } else {

        const currentRoutes = changes.routes.currentValue || [];
        const previousRoutes = changes.routes.previousValue || [];

        const routesToAdd = _.differenceBy(currentRoutes, previousRoutes, 'id');
        const routesToRemove = _.differenceBy(previousRoutes, currentRoutes, 'id');


        const currentUpdatedRoutes = _.differenceBy(currentRoutes, routesToAdd, 'id');
        const previousUpdatedRoutes: any = _.differenceBy(previousRoutes, routesToRemove, 'id');

        const currentRoutesToUpdate = _.filter(currentUpdatedRoutes, (currentUpdatedRoute: any) => {
          const previousUpdatedRoute = _.find(previousUpdatedRoutes, ['id', currentUpdatedRoute.id]);
          // Check if route was changed
          return previousUpdatedRoute.updatedTime < currentUpdatedRoute.updatedTime;
        });

        // Routes - REMOVE LINE TASKS
        if (!!routesToRemove.length) {
          // groupsDataSet.remove(_.map(routesToRemove, 'id'));
          this.itemsDataSet.remove(_.map(routesToRemove, 'id'));
        }

        // Routes - UPDATE LINE TASKS
        if (!!currentRoutesToUpdate.length) {
          const updatedRouteItems = [];
          _.forEach(currentRoutesToUpdate, (r) => {
            updatedRouteItems.push(this._getRouteBackgroundItem(r));
          })
          this._updateTimelineTasks(updatedRouteItems);
        }

        // Routes - ADD LINE TASKS
        if (routesToAdd.length) {
          this._addRoutesBackgroundToTimeline(routesToAdd);
        }
        // this.initRoutesTasks(this.routes);
      }

      this.redrawGroupTemplate();
    }

    if (changes.tasks && !changes.tasks.isFirstChange()) {
      // const currentTasks = changes.tasks.currentValue || [];
      if (!this.isShowUtilization) {
        this.initRoutesTasks(this.tasks);
      }
    }

    if (changes.range && !changes.range.isFirstChange()) {
      this.options.start = this.moment(this.range.dateStart) ? this.moment(this.range.dateStart).subtract(1, 'hour') : this.moment().startOf('day');
      this.options.end = this.moment(this.range.dateEnd) ? this.moment(this.range.dateEnd).add(1, 'hour') : this.moment().endOf('day');
      this.options.min = this.moment(this.range.dateStart);
      this.options.max = this.moment(this.range.dateEnd);
      this.timeline.setOptions(this.options);
      this.timeline.setWindow(new Date(this.range.dateStart), new Date(this.range.dateEnd));
    }

    if (changes.isTooltipsEnabled && !changes.isTooltipsEnabled.isFirstChange()) {
      this.options.showTooltips = !!this.isTooltipsEnabled;
      this.timeline.setOptions(this.options);
    }

    if (changes.isShowTaskColorByAgent && !changes.isShowTaskColorByAgent.isFirstChange()) {
      this._redrawTasks(this.tasks)
    }

    if (changes.isShowUtilization && !changes.isShowUtilization.isFirstChange()) {
      this.itemsDataSet.clear();

      // Init Routes Utilization/Task Items
      if (this.isShowUtilization) {

        // Add Routes Utilization Items
        if (this.routes?.length) {
          this.itemsDataSet.add(this._getRoutesUtilizationItemsData(this.routes));
        }
      } else {

        // Add Schedule Items
        if (this.schedules?.length) {
          this.itemsDataSet.add(this._getScheduleItemsData(this.schedules));
          this.itemsDataSet.add(this._getScheduleBreaksItemsData(this.schedules));
        }

        // Init Routes Items
        if (this.routes?.length) {

          // Add Routes Background Items
          this._addRoutesBackgroundToTimeline(this.routes);

          // Add Routes Tasks Items
          this.initRoutesTasks(this.tasks);
        }
      }
    }

    if (changes.isLoading && !changes.isLoading.isFirstChange()) {
      // this.options.editable.overrideItems = this.isLoading;
      this.options.editable = {
        add: true,
        updateTime: !this.isLoading,
        updateGroup: !this.isLoading,
        remove: false,
        overrideItems: true
      };
      this.timeline.setOptions(this.options);
    }
  };

  // ******************************
  //        Public methods
  // ******************************

  initRoutesTasks(tasks) {

    // Server Bugfixes
    _.forEach(tasks, (t) => {
      if (t.packageList?.length) {
        if (t.packageList[0] && !t.packageList[0].items) {
          t.packageList[0] = {items: t.packageList[0]};
        }
      }

      // t.routeId = r.id;
      const routeRef = _.find(this.routes, (r) => {
        return r.id === t.routeId;
      })
      if (!!routeRef) {
        t.agentId = routeRef.agentId;
      }
    })

    this._setTasks(tasks)
  }

  private _setTasks(tasks) {
    let tasksToAdd = [];
    let idsToRemove = [];
    let idsToUpdate = [];

    const taskIds = _.flatMap(tasks, 'id');
    const currentTimelineItems = [];
    this.itemsDataSet.forEach((item) => {
      if (item.itemType === 'TASK') {
        currentTimelineItems.push(item.id);

        if (_.includes(taskIds, item.id)) {
          const taskRef = _.find(tasks, (t) => {
            return t.id === item.id;
          })
          if (_.get(taskRef, 'updatedAt', 0) >= _.get(item, 'updatedAt', 0)) {
            idsToUpdate.push(item.id);
          }
        }

      }
    });
    idsToRemove = _.filter(currentTimelineItems, (currentItemId) => {
      return !_.includes(taskIds, currentItemId);
    })
    tasksToAdd = _.filter(tasks, (t) => {
      return !_.includes(currentTimelineItems, t.id);
    })

    // Remove
    if (idsToRemove.length) {
      this.itemsDataSet.remove(idsToRemove);
    }

    // Update
    if (idsToUpdate.length) {
      const tasksToUpdate = _.filter(tasks, (t) => {
        return _.includes(idsToUpdate, t.id);
      })
      const taskItemsToUpdate = this._getTasksItemsData(tasksToUpdate);

      if (_.get(taskItemsToUpdate, 'length')) {
        this.itemsDataSet.remove(_.map(taskItemsToUpdate, 'id'))
        this.itemsDataSet.add(taskItemsToUpdate);

        // itemsDataSet.update(taskItemsToUpdate);
      }
    }

    // Add
    if (tasksToAdd.length) {
      const taskItemsToAdd = this._getTasksItemsData(tasksToAdd);

      if (_.get(taskItemsToAdd, 'length')) {
        this.itemsDataSet.remove(_.map(taskItemsToAdd, 'id'))
        this.itemsDataSet.add(taskItemsToAdd);
      }
    }
  }

  onZoom(isZoomIn) {
    isZoomIn ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
  }

  onExpand(isExpandedRoutes) {
    this.isExpandedRoutes = isExpandedRoutes;
    this._setExpandedGroupsRoutes(isExpandedRoutes);
  }

  onFit() {
    this.timeline.fit();
  }

  onGroupsViewSettingsChange(updatedGroupsViewSettings) {
    this.groupsViewSettings = updatedGroupsViewSettings;
    this.redrawGroupTemplate();
    this.onSettingsChange({settings: updatedGroupsViewSettings})
  }


  // ******************************
  //        Private methods
  // ******************************

  _getGroupsData(agents) {


    const agentsGroups = [];

    _.forEach(agents, (a, index) => {
      agentsGroups.push(this._getAgentsGroup(a, index));
    })

    return agentsGroups;
  }

  private _getTranslatedSkills(skills, isFirstLetterOnly?) {
    return _.map(skills, (s) => {
      let text;

      if (this.siteSkills[s].custom) {
        text = this.siteSkills[s].name;
      } else {
        text = this.$filter('translate')('SKILLS.' + this.siteSkills[s].name);
      }
      return isFirstLetterOnly ? text.charAt(0) : text;
    });
  }

  private _getScheduleBreaksItemsData(schedules) {
    let items = [];

    _.forEach(schedules, (s) => {
      _.forEach(s.scheduleExtraData, (extraData) => {
        _.forEach(extraData.breaks, (b) => {
          const exceptions = _.get(s, 'agentSchedule.schedule.exceptions', []);

          if (exceptions.length) {
            const isException = _.find(exceptions, (e) => {
              return this.moment(extraData.eventDate).isSame(this.moment(e), 'date');
            })
            if (isException) {
              return;
            }
          }
          items.push(this._getScheduleBreakItemData(s, b, s.agentId, s.id)) //AgentScheduleBreak
        })
      })
    });

    return items;
  }

  private _getScheduleItemsData(schedules) {
    let items = [];
    const monthInMili = 2592000000;


    _.forEach(schedules, (item) => {

      const scheduleRecurringString = _.get(item, 'agentSchedule.schedule.rrule', '');

      // OLD IMPLEMENTATION
      if (scheduleRecurringString && false) {
        const ruleOptions = this.rrule.RRule.parseString(scheduleRecurringString);

        ruleOptions.dtstart = this.moment(item.agentSchedule.schedule.startRecurring).utc(true).toDate()
        if (item.agentSchedule.schedule.endRecurring) {
          ruleOptions.until = this.moment(item.agentSchedule.schedule.endRecurring).utc(true).toDate();
        }

        const rule = new this.rrule.RRule(ruleOptions);
        let dates = rule.between(new Date(this.range.dateStart - monthInMili), new Date(this.range.dateEnd + monthInMili));

        // convert to local
        dates = _.map(dates, (d) => {
          return this.moment(d).set({
            year: this.moment.utc(d).year(),
            month: this.moment.utc(d).month(),
            date: this.moment.utc(d).date()
          }).startOf('day').toDate();
        })

        const exceptions = _.get(item, 'agentSchedule.schedule.exceptions', []);


        items = items.concat(
          this._parseReacquiringItemsByType(item, dates, exceptions) //AgentSchedule
        );
      } else {
        items.push(this._parseAgentScheduleToItem(item));
      }
    });

    this._assignAvailabilityOverlapLanes(items);

    return items;
  }

  // Availability items for the same agent can overlap in time. Since they're rendered
  // as thin lines pinned to the bottom of the row (not vis-timeline's own stacking),
  // give each overlapping one a lane index so the CSS can offset it further up.
  private _assignAvailabilityOverlapLanes(items) {
    const maxLane = 3;

    const availabilityItemsByAgent = _.groupBy(
      _.filter(items, (i) => i.itemSubType === ScheduleType.Availability),
      'agentId'
    );

    _.forEach(availabilityItemsByAgent, (agentItems) => {
      const sortedItems = _.sortBy(agentItems, (i) => i.start.valueOf());
      const laneEndTimes = [];

      _.forEach(sortedItems, (item) => {
        const itemStart = item.start.valueOf();
        const itemEnd = item.end.valueOf();

        let laneIndex = _.findIndex(laneEndTimes, (endTime) => endTime <= itemStart);
        if (laneIndex === -1) {
          laneIndex = laneEndTimes.length;
        }
        laneEndTimes[laneIndex] = itemEnd;

        if (laneIndex > 0) {
          item.className += ` overlap-${Math.min(laneIndex, maxLane)}`;
        }
      });
    });
  }

  private _onClicked() {
    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
  }

  private _addRoutesBackgroundToTimeline(routes) {
    let backgroundItems = [];

    _.forEach(routes, (r) => {
      backgroundItems = backgroundItems.concat(this._getRouteBackgroundItem(r));
    });

    this.itemsDataSet.add(backgroundItems);
  }

  private _getRouteBackgroundItem(route) {
    return {
      id: route.rid,
      ref: route,
      routeId: route.rid,
      start: this.moment(route.notBefore),
      end: this.moment(route.notAfter),
      group: _.get(route, 'agentId'),
      type: 'background',
      itemType: 'ROUTE',
      className: 'route-background'
    }
  }

  private redrawGroupTemplate() {
    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      group.priorityServiceAreas = this._getServiceAreasByIds(group.priorityServiceAreasIds || []);
      updatedGroups.push(group);
    });

    this.groupsDataSet.update(updatedGroups);
    // timeline.setGroups(updatedGroups);
  }

  private _setExpandedGroupsRoutes(isEnabled, doReorder?) {
    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      group.showNested = isEnabled;
      if (doReorder) {
        group.order = _.findIndex(this.agents, (a: any) => {
          return a.id === group.id;
        })
      }
      updatedGroups.push(group);
    });

    this.groupsDataSet.update(updatedGroups);
  }

  private _clearScheduleItems() {
    const itemsToClear = [];
    this.itemsDataSet.forEach((item) => {
      if (item.itemType === 'SCHEDULE' || item.itemType === 'BREAK') {
        itemsToClear.push(item.id);
      }
    });
    this.itemsDataSet.remove(itemsToClear);
  }

  private _updateTimelineTasks(taskItems) {
    const itemsToUpdate = [];

    this.itemsDataSet.forEach((item) => {
      if (_.includes(_.map(taskItems, 'id'), _.get(item, 'id'))) {
        itemsToUpdate.push(item.id);
      }
      // if (!item.itemType === 'ROUTE' && _.includes(tasksIds, item.id)) {
      //   itemsToUpdate.push(item.id);
      // }
    });
    this.itemsDataSet.update(_.filter(taskItems, (t) => {
      return _.includes(itemsToUpdate, t.id)
    }));
    // itemsDataSet.remove(itemsToUpdate);
    // timeline.setItems(itemsToUpdate);
  }

  private _getTasksItemsData(tasks) {
    return _.map(tasks, (task) => {
      const agentId = task.agentId;
      const routeColor = this._getColorByAgentId(agentId);
      const index = _.get(task, 'routeAnalysis.daySequence');

      const taskPurpose = task.taskSpec.purpose;
      const taskServiceTime = _.get(task, 'routeAnalysis.serviceTime');
      const isPoint = _.isEqual(task.taskType, 'Internal');
      const isBundle = _.isEqual(task.taskType, 'BundledStopover');
      const isBreak = _.isEqual(taskPurpose, 'Break');
      let taskEta = _.get(task, 'routeAnalysis.eta');
      const taskEtd = _.get(task, 'routeAnalysis.etd', (taskEta + taskServiceTime));
      const relations = _.get(task, 'relations', []);
      const taskNotBefore = _.get(task, 'taskSpec.notBefore');
      const updatedAt = _.get(task, 'updatedAt');

      if (taskEta < taskNotBefore) {
        taskEta = taskNotBefore
      }

      const taskEtaWindow = this.$filter('timeWindow')({notBefore: taskEta, notAfter: taskEtd});


      let className = isPoint ? 'internal route-item' : (isBundle ? 'bundle route-item' : (isBreak ? 'task route-item break' : 'task route-item'))
      let style;

      if (isPoint) {
        style = 'background-color: #7E7E7E !important; color: white;';
      } else {
        style = 'color: white;';
        if (this.isShowTaskColorByAgent) {
          style = 'background-color: ' + routeColor + '; color: white;';
        } else {
          className += ` ${task.status}`;
          style = 'color: white;';
        }
      }

      if (isBundle) {
        style += ' box-shadow: 2px -2px 0px ' + this.commonsService.lightenDarkenColor(routeColor, -35) + ';';
      }

      return {
        ref: task,
        id: task.id,
        itemType: 'TASK',
        status: task.status,
        // id: route.rid + task.id,
        start: this.moment(taskEta),
        end: this.moment(taskEtd),
        startTime: this.moment(taskEta),
        endTime: this.moment(taskEtd),
        purpose: taskPurpose,
        taskIdList: _.get(task, 'taskIdList'), // For Bundle Only
        point: isPoint ? 'point' : 'box',
        taskType: task.taskType,
        serviceId: task.serviceId,
        serviceIds: task.bundleServiceIdList,
        group: agentId,
        agentId: agentId,
        resourceId: agentId,
        routeId: task.routeId,
        taskId: task.id,
        updatedAt: updatedAt,
        className: className,
        editable: {
          add: false,                          // add new items by double tapping
          updateTime: true,                // drag items horizontally
          updateGroup: true,              // drag items from one group to another
          remove: false                 // delete an item by tapping the delete button top right
        },
        // subgroup: route.rid,
        title: this.bringozTimelineService.getRouteTaskExtendedTimelineItemTooltip(task, taskEtaWindow, undefined),
        content: isPoint ?
          this.bringozTimelineService.getRouteInternalItemContent(task, this.isShowTaskColorByAgent) :
          (isBundle ?
            this.bringozTimelineService.getRouteBundleTaskTimelineItemContent(task, relations, this.isShowTaskColorByAgent, index) :
            this.bringozTimelineService.getRouteTaskTimelineItemContent(task, relations, this.isShowTaskColorByAgent, index)),
        style: style,
      }
    });
  }

  private _getRoutesUtilizationItemsData(routes) {
    return _.map(routes, (r) => {
      const agentId = r.agentId;
      const scheduleLengthInSeconds = this.moment(r.planningResource.notAfter).diff(r.planningResource.notBefore, 'seconds');
      const utilizationPercentage = Math.round((100 * (r.totals.totalServiceTimeSec + r.totals.totalTravelTimeSec)) / scheduleLengthInSeconds);

      const routeDate = this.moment(_.get(r, 'planningResource.notAfter', r.notBefore)).valueOf();
      let itemStart = this.moment(routeDate).set({
        'hour': 5,
        'minute': 0,
        'second': 0,
        'millisecond': 0
      }).valueOf()
      const itemEnd = this.moment(routeDate).set({
        'hour': 19,
        'minute': 0,
        'second': 0,
        'millisecond': 0
      }).valueOf()


      const utilizationPercentageClass = _getClassNameByUtilization(utilizationPercentage);
      let className = `utilization ${utilizationPercentageClass}`

      function _getClassNameByUtilization(value) {
        if (value > 100) {
          return 'high';
        } else if (value < 100 && value >= 50) {
          return 'medium';
        } else {
          return 'low';
        }
      }


      return {
        ref: r,
        id: r.id,
        itemType: 'UTILIZATION',
        start: this.moment(itemStart),
        end: this.moment(itemEnd),
        startTime: this.moment(itemStart),
        endTime: this.moment(itemEnd),
        point: 'box',
        group: agentId,
        agentId: agentId,
        routeId: r.id,
        updatedAt: r.updatedAt,
        className: className,
        editable: {
          add: false,                          // add new items by double tapping
          updateTime: false,                // drag items horizontally
          updateGroup: false,              // drag items from one group to another
          remove: false                 // delete an item by tapping the delete button top right
        },
        // title: this.bringozTimelineService.getRouteTaskExtendedTimelineItemTooltip(task, taskEtaWindow, undefined),
        content: `${utilizationPercentage}%`
      }
    });
  }

  private _getColorByAgentId(id) {
    const agent: AgentModel = _.find(this.agents, (a: AgentModel) => {
      return a.id === id;
    })
    return agent?.displayColor || this.commonsService.getColorById(id, this.colorPallet);
  }

  // private _getColorByAgentId(id) {
  //
  //   const agentIndex = _.findIndex(this.agents, (a: AgentModel) => {
  //     return a.id === id;
  //   })
  //
  //   if (agentIndex > -1) {
  //     return this.agents[agentIndex].displayColor || this.colorPallet[agentIndex];
  //   } else {
  //     const randomIndex = Math.floor(Math.random() * this.agents.length);
  //     return this.colorPallet[randomIndex];
  //   }
  // }

  private _schedulesToMoveTo(task) {
    const schedules = [];
    if (_.isEqual(task.taskType, 'Internal')) {
      return [];
    }

    this.itemsDataSet.forEach((item) => {
      if (item.itemType === 'SCHEDULE' && _.isEqual(task.group, item.group)) {
        if (_.isEqual(this.moment(task.start).valueOf(), this.moment(item.start).valueOf()) ||
          this.moment(task.start).isBetween(this.moment(item.start), this.moment(item.end))
        ) {
          schedules.push(item)
        }
      }
    });
    return schedules;
  }

  private _getRouteByScheduleId(scheduleId) {
    return _.find(this.routes, (r) => {
      return r.planningResource.allocationInstanceId === scheduleId;
    });
  }

  private _getAgentsGroup(a, index) {
    const isEven = (index % 2) === 0;
    let className = 'group-row br-caption-2';
    className += !!isEven ? ' even' : ' odd';
    className += ' agent-left-container';

    return {
      id: a.id,
      agentId: a.id,
      name: this.$filter('userName')(a.user),
      nameInitials: this.$filter('userInitials')(a.user),
      agentType: this.$filter('translate')(_.get(a, 'agentType', '')),
      skills: this._getTranslatedSkills(a.skills),
      tags: a.tags,
      requiredSkills: a.skills,
      branchReferences: _.get(a, 'branchReferences'),
      employmentType: this.$filter('translate')(a.employmentType),
      priorityServiceAreas: this._getServiceAreasByIds(_.get(a, 'agentPreferencesReference.priorityServiceAreas', [])),
      priorityServiceAreasIds: _.get(a, 'agentPreferencesReference.priorityServiceAreas', []),
      vehicleType: a.vehicleType,
      status: a.status,
      className: className,
      taskCount: _.get(a, 'itineraryInfo.numberOfTasks', 0),
      ref: a,
      order: index,
      showNested: true
    }
  }

  private _parseAgentScheduleToItem(item) {
    const route = this._getRouteByScheduleId(item.agentSchedule.id);

    return {
      itemType: 'SCHEDULE',
      itemSubType: item.agentSchedule.type,
      start: this.moment(item.agentSchedule.schedule.startTime),
      end: this.moment(item.agentSchedule.schedule.endTime),
      id: item.agentSchedule.id,
      // id: item.agentSchedule.id + ':Tag:' + item.agentId + ':Date:' + this.moment(item.agentSchedule.schedule.startTime).format("DD-MM-YYYY"),
      group: item.agentId,
      agentId: item.agentId,
      ref: item,
      editable: {
        add: false,                          // add new items by double tapping
        updateTime: !this.isLoading,                   // drag items horizontally
        updateGroup: false,              // drag items from one group to another
        remove: false,                 // delete an item by tapping the delete button top right
        overrideItems: this.isLoading          // allow these options to override item.editable
      },
      selectable: true,
      title: this.bringozTimelineService.getShiftTimelineItemTooltip(item, route, this.serviceAreas),
      content: this.isShowScheduleContentEnabled ?
        this.bringozTimelineService.getShiftContentNew(item, item.agentSchedule.schedule.startTime, item.agentSchedule.schedule.endTime) :
        undefined,
      className: `schedule ${item.agentSchedule.type}`
      // type: 'background',
    }
  }

  private _parseReacquiringItemsByType(item, dates, exceptions) {

    if (exceptions.length) {
      dates = _.filter(dates, (d) => {
        const exception = _.find(exceptions, (e) => {
          return this.moment(d).isSame(this.moment(e), 'date');
        });
        return _.isUndefined(exception);
      });
    }
    return _.map(dates, (date) => {
      const dateToDifferenceInMili = this.moment(item.agentSchedule.schedule.endTime).diff(this.moment(item.agentSchedule.schedule.startTime));
      const dateFrom = this.moment(date).set({
        year: this.moment(date).year(),
        month: this.moment(date).month(),
        date: this.moment(date).date(),
        hour: this.moment(item.agentSchedule.schedule.startTime).hours(),
        minute: this.moment(item.agentSchedule.schedule.startTime).minutes(),
        second: this.moment(item.agentSchedule.schedule.startTime).seconds()
      });
      const dateTo = this.moment(dateFrom.valueOf() + dateToDifferenceInMili);
      const route = this._getRouteByScheduleId(item.agentSchedule.id);
      return {
        // id: moment(date).valueOf() + '-' + item.agentSchedule.id, //AgentSchedule
        id: item.agentSchedule.id,
        // id: item.agentSchedule.id + ':Tag:' + item.agentId + ':Date:' + this.moment(date).format("DD-MM-YYYY"),
        itemType: 'SCHEDULE',
        itemSubType: item.agentSchedule.type,
        scheduleId: item.agentSchedule.id,
        start: this.moment(dateFrom).add(15, 'minute'),
        end: this.moment(dateTo).subtract(15, 'minute'),
        startTime: dateFrom,
        endTime: dateTo,
        group: item.agentId,
        agentId: item.agentId,
        ref: item,
        editable: false,
        title: this.bringozTimelineService.getShiftTimelineItemTooltip(item, route, this.serviceAreas),
        // content: this.bringozTimelineService.getShiftContentNew(item, dateFrom, dateTo, true),
        className: `schedule ${item.agentSchedule.type}`
        // type: 'background',
      }
    })
  }

  private _getScheduleBreakItemData(schedule, breakData, agentId, scheduleId) {
    const route = this._getRouteByScheduleId(schedule.id);
    return {
      // id: moment(date).valueOf() + '-' + item.agentSchedule.id, //AgentSchedule
      id: breakData.id + '-break',
      itemType: 'BREAK',
      start: this.moment(breakData.notBefore),
      end: this.moment(breakData.endDate ? breakData.endDate : (breakData.notBefore + breakData.duration)),
      startTime: breakData.notBefore,
      endTime: breakData.endDate,
      group: agentId,
      agentId: agentId,
      ref: breakData,
      scheduleId: scheduleId,
      editable: false,
      title: this.bringozTimelineService.getShiftTimelineItemTooltip(schedule, route, this.serviceAreas),
      // content: this.bringozTimelineService.getShiftContentNew(item, dateFrom, dateTo, true),
      className: 'break',
      selectable: true
      // type: 'background'
    }
  }

  private _getServiceAreasByIds(ids) {
    const serviceAreas = this.serviceAreas || [];
    return serviceAreas.length ? serviceAreas.filter((area) => {
      return ids.includes(area.id);
    }) : [];
  }

  private _canAddToRoute(leftovers, toRouteId) {
    const route = _.find(this.routes, (r) => {
      return r.id === toRouteId;
    })
    let canAddBulk = true;
    _.forEach(leftovers, (l) => {
      const resourceSkills = _.get(route, 'resource.allocationSkills', []);
      const leftoverSkill = _.get(l, 'skills.length') ? l.skills[0] : (l.jobType === 'Operation' ? 'Merchandise' : 'Delivery');

      if (!_.includes(resourceSkills, leftoverSkill)) {
        const stopType = this.$filter('translate')('SKILLS.' + leftoverSkill);
        const routeType = this.$filter('translate')('SKILLS.' + resourceSkills[0]);
        // this.planningAlertsService.stopTypeToRouteRejectionInfo(stopType, routeType);
        canAddBulk = false;
        return false;
      }
    })
    return canAddBulk;
  }

  private _redrawTasks(tasks) {
    const tasksCopy = angular.copy(tasks);

    // Server Bugfixes
    _.forEach(tasksCopy, (t) => {
      if (t.packageList?.length) {
        if (t.packageList[0] && !t.packageList[0].items) {
          t.packageList[0] = {items: t.packageList[0]};
        }
      }

      // t.routeId = r.id;
      const routeRef = _.find(this.routes, (r) => {
        return r.id === t.routeId;
      })
      if (!!routeRef) {
        t.agentId = routeRef.agentId;
      }
    })

    const tasksItems = this._getTasksItemsData(tasksCopy);
    this._updateTimelineTasks(tasksItems);
  }

  $onDestroy() {
    if (this.container) {
      this.container.removeEventListener('click', this._onContainerClick);
      this.container = null;
    }
    if (this.timeline) {
      this.timeline.destroy();
      this.timeline = null;
    }
    if (this.itemsDataSet) {
      this.itemsDataSet.clear();
      this.itemsDataSet = null;
    }
    if (this.groupsDataSet) {
      this.groupsDataSet.clear();
      this.groupsDataSet = null;
    }
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentsScheduleTimelineBeta', {
    bindings: {
      agents: '<',
      schedules: '<',
      routes: '<',
      tasks: '<',
      serviceAreas: '<',
      totals: '<?',
      range: '<',
      query: '<',
      isLoading: '<',
      isSortMode: '<',
      isTooltipsEnabled: '<',
      isShowScheduleContentEnabled: '<',
      isShowTaskColorByAgent: '<',
      isShowUtilization: '<',
      agentsGroup: '<',
      highlightedSchedules: '<?',
      highlightedTasks: '<?',
      isFavouriteAgentsMode: '<?',
      favouriteAgentIds: '<?',
      settings: '<?',
      onScheduleSelect: '&',
      onViewService: '&',
      onAxisClick: '&',
      onBreakRightClick: '&',
      onRightClickTask: '&',
      onRightClickSchedule: '&',
      onCreateSchedule: '&',
      onMoveGroup: '&',
      onMoveItem: '&',
      onTaskChange: '&',
      onDatesPageChange: '&',
      onAgentsGroupChange: '&',
      onToggleHighlightSchedule: '&',
      onHighlightedItemsChange: '&',
      onAgentColorClick: '&',
      onToggleIsFavouriteAgentsMode: '&',
      onToggleFavouriteAgent: '&',
      onResetFavouriteAgents: '&',
      onUpdateShift: '&',
      onSort: '&',
      onSettingsChange: '&',
      addServicesToRoute: '&',
      addServicesToNewRoute: '&'
    },
    template: require('./agents-schedule-timeline-beta.html').default,
    controller: AgentsScheduleTimelineBetaCtrl
  });
